export const mergeArray = (elements, type) => {
  return Array.isArray(elements) ? elements.map(e => e[type]).join(",") : ""
}
